.hoverContainer {
}

.hoverMenu {
  display: none;
  .hoverContainer:hover & {
    display: inline-block;
  }
}

.hoverMenuPinned {
  display: inline-block;
}
